module.exports = __webpack_public_path__ + "img/carousel-servicios-3.e8f04e89.jpg";